import { useDispatch, useSelector } from 'react-redux';
import Icon, { Icons } from '../../components/Icon/Icon';
import PageHeader from '../../components/PageHeader';
import { LOCALES_INFO, t } from '../../lang';

import ListItem from '../../components/ListItem';
import { localizationSlice } from '../../store/slices';
import './Languages.scss';

const localeOptions = Object.values(LOCALES_INFO);

const Languages = () => {
	const activeLang = useSelector(state => state.localization.lang);
	const dispatch = useDispatch();

	const onChangeLanguage = lang => {
		if (activeLang !== lang) {
			localStorage.setItem('lang', lang.name);
			dispatch(localizationSlice.actions.setLanguage(lang.name));
		}
	};

	const LANGUAGE_ICONS = {
		en: Icons.ENGLISH,
		ru: Icons.RUSSIAN,
		uk: Icons.UKRAINE,
	};

	return (
		<>
			<div className='Languages'>
				<PageHeader />
				<div className='Languages__body'>
					<h2>{t('Interface language')}</h2>

					<div className='Language__body-content FormBlock'>
						{localeOptions.map((lang, i) => {
							const isActive = activeLang === lang.name;
							const isLast = i !== localeOptions.length - 1;

							return (
								<div key={lang.name} className={`Language-item ${isActive ? 'active' : ''}`}>
									<ListItem
										className={'Languages__item-li'}
										icon={<Icon type={LANGUAGE_ICONS[lang.name]} width={32} height={32} />}
										title={lang.title}
										description={t(lang.title)}
										bottomSeparator={isLast}
										rightTitle={
											isActive ? (
												<Icon className='Language-item-check' type={Icons.CHECKMARK} width={24} height={24} />
											) : (
												''
											)
										}
										onSelect={() => onChangeLanguage(lang)}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</>
	);
};

export default Languages;
